/* eslint-disable consistent-return */
import { apiPaths, httpStatus } from '../../constants'
import { Api } from '../../middlewares'
import { Logger, LoggerTypes } from '../../utils'

// -- GET (array of objects)
export const GET_ALPHA_FACTORS_SUCCESS = 'GET_ALPHA_FACTORS_SUCCESS'
export const GET_ALPHA_FACTORS_FAILURE = 'GET_ALPHA_FACTORS_FAILURE'

// ____________________________________________________________

let cacheItems = null

/**
 * Get the alpha factors form the API and broadcast two types of events:
 * - GET_ALPHA_FACTORS_SUCCESS: in case of success
 * - GET_ALPHA_FACTORS_FAILURE: in case of failure.
 *
 * @returns {Promise<object>}
 */
export const getAlphaFactors = () => async (dispatch) => {
  if (!cacheItems) {
    const api = new Api(apiPaths.ALPHA_FACTOR_LIST)
    const result = await api.get()

    if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
      cacheItems = result.data || []
    } else {
      cacheItems = result.data

      return dispatch({
        type: GET_ALPHA_FACTORS_FAILURE,
        data: result.data
      })
    }
  }

  Logger.trace(LoggerTypes.ACTION, '[ACTION] alphaFactorActions.getAlphaFactors()', { cacheItems })

  return dispatch({
    type: GET_ALPHA_FACTORS_SUCCESS,
    data: cacheItems
  })
}
